module.exports = __webpack_public_path__ + "img/section8-2-index.ef37e9e1.png";